
















































































































































































































































































































































































































import Vue, { PropType } from "vue";
import type { EditorConfiguration } from "codemirror";
import ReviewHeader from "@/parts/review/ReviewHeader.vue";
import VariableInput from "@/components/util/VariableInput.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import { codemirror } from "vue-codemirror";
import AddSkillModal from "@/parts/util/AddSkillModal.vue";
import { getDaysCountToEndDate } from "@/utils/momentUtils";
import HelperTooltip from "@/parts/common/HelperTooltip.vue";
import { getColorClass } from "@/utils/styleUtils";

import moment from "moment";

import { CodeEditorSegmegment } from "@/api/dto/CodeEditor";
import { Language, Skill, SkillMastar } from "@/api/dto/Skill";
import { getReview, deleteReview, createReview, updateReview, updateReviewStatus } from "@/api/Review";
import store, { emptyReviewForm } from "@/store";
import { UserProfile } from "@/api/dto/UserProfile";
import { genericExtension } from "@/properties";
import { Draft, Pending } from "@/api/dto/DealStatus";
import { PurchaseType } from "@/api/dto/PurchaseType";
import { AutoTenderType, TenderPriority, ReviewResponse } from "@/api/dto/Review";
import {
  OPTION_1_DAY,
  OPTION_1_MONTH,
  OPTION_1_WEEK,
  OPTION_3_DAY,
  OPTION_UNLIMITED,
  PublishedOption,
  ReviewForm,
  toCreateReviewRequestFromReviewForm,
  toUpdateReviewRequestFromReviewForm,
} from "./ReviewForm";
import { getUserProfile } from "@/api/UserProfile";
import { getFreeTime } from "@/api/FreeTime";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

/**
 * 期限
 */
const publishedPeriodOptions = {
  [OPTION_1_DAY]: {
    value: OPTION_1_DAY,
    text: "1日",
    addCount: 1,
    unit: "days",
  },
  [OPTION_3_DAY]: {
    value: OPTION_3_DAY,
    text: "3日",
    addCount: 3,
    unit: "days",
  },
  [OPTION_1_WEEK]: {
    value: OPTION_1_WEEK,
    text: "7日",
    addCount: 7,
    unit: "days",
  },
  [OPTION_1_MONTH]: {
    value: OPTION_1_MONTH,
    text: "30日",
    addCount: 30,
    unit: "days",
  },
  [OPTION_UNLIMITED]: {
    value: OPTION_UNLIMITED,
    text: "60日",
    addCount: 60,
    unit: "days",
  },
} as const;

/**
 * 作成日と期限の日付 -> 期限option
 */
const toPublishedPeriodOption = (from: moment.Moment, to: moment.Moment): PublishedOption => {
  const diffDays = Math.round(to.diff(from, "days", true));
  if (diffDays <= 1) {
    return OPTION_1_DAY;
  } else if (diffDays <= 3) {
    return OPTION_3_DAY;
  } else if (diffDays <= 7) {
    return OPTION_1_WEEK;
  } else if (diffDays <= 31) {
    return OPTION_1_MONTH;
  } else {
    return OPTION_UNLIMITED;
  }
};

/**
 *  レビュー詳細取得からレビューフォームに変換
 */
const toReviewFormFromGetReview = (res: ReviewResponse): ReviewForm => {
  const optionValue = toPublishedPeriodOption(
    moment(res.createDate),
    moment(res.publishedPeriod, "YYYY/MM/DD HH:mm:ss")
  );

  return {
    dealId: res.dealId,
    dealStatus: res.dealStatus,
    language: res.language,
    title: res.title,
    purchaseOverview: res.purchaseOverview,
    codeEditor: res.codeEditor,
    tags: res.tags,
    amount: res.amount,
    publishedPeriod: res.publishedPeriod,
    selectPublishedPeriod: optionValue,
    orderSkills: res.orderSkills,
    createDate: res.createDate,
    purchaseType: res.purchaseType,
    limitCount: res.limitCount,
    autoTenderType: res.autoTenderType,
    tenderPriority: res.tenderPriority,
    viewPermission: res.viewPermission,
    isUseCoupon: res.isUseCoupon,
  };
};

/**
 * option値 -> 掲載期限
 */
const calcPublishedPeriod = (now: moment.Moment, option: PublishedOption): moment.Moment => {
  const { addCount, unit } = publishedPeriodOptions[option];
  return now.add(addCount, unit);
};

export default Vue.extend({
  name: "ReviewEdit",
  components: {
    ReviewHeader,
    VariableInput,
    SelectBox,
    codemirror,
    AddSkillModal,
    HelperTooltip,
  },
  props: {
    loginData: Object as PropType<UserProfile>,
    mq: String,
  },
  data() {
    /** 受注方法 */
    const optionPurchaseType = [
      { value: 1, text: "入札" },
      { value: 2, text: "即決" },
    ];
    /** 希望金額 */
    const optionAmount = [
      { value: 0, text: "3,000" },
      { value: 1, text: "4,000" },
      { value: 2, text: "5,000" },
      { value: 3, text: "自分で入力" },
    ];
    /** 入札人数上限 */
    const optionLimitCount = [
      { value: 0, text: "設定なし" },
      { value: 5, text: "5人" },
      { value: 10, text: "10人" },
      { value: 20, text: "20人" },
    ];
    /** 自動再掲載 */
    const optionAutoTenderType = [
      { value: 2, text: "再掲載しない" },
      { value: 1, text: "再掲載する" },
    ];
    /** 落札の優先度設定 */
    const optionTenderPriority = [
      { value: 0, text: "未設定" },
      { value: 1, text: "スキルが最も高い" },
      { value: 2, text: "評価が最も高い" },
      { value: 3, text: "金額が最も安い" },
      { value: 4, text: "金額が最も高い" },
    ];
    /** 受注必須スキル */
    const optionOrderSkill = [
      { value: 0, text: "なし" },
      { value: 1, text: "あり" },
    ];
    return {
      reviewData: {} as ReviewForm,
      // メイン言語 関連
      mainLangModal: false,
      // コードエディター 関連
      countCodeBlock: 0,
      optionExtension: [] as { value: number; text: string }[],
      code: [] as Array<string>,
      cmOptions: [] as Array<EditorConfiguration>,
      selectedCodeEditor: 0,
      // 受注方法関連
      optionPurchaseType,
      // 金額 関連
      optionAmount,
      selectAmount: 0,
      showInputAmount: false,
      inputAmount: "",
      // 入札人数上限関連
      optionLimitCount,
      // 掲載期限 関連
      optionPublishedPeriod: Object.values(publishedPeriodOptions),
      // 自動再掲載
      optionAutoTenderType,
      // 落札の優先度設定
      optionTenderPriority,
      // タグ 関連
      tagLangModal: false,
      // 受注必須スキル 関連
      optionOrderSkill,
      selectOrderSkill: 0,
      showOrderSkills: false,
      orderSkills: [] as Skill[],
      // モーダル 関連
      modalOpen: false,
      reaveModal: false,
      deleteEditorModal: false,
      deleteModal: false,
      draftModal: false,
      // 汎用
      allowLeave: false,
      goBack: false,
      nextPath: "",
      // 変更前の言語
      beforeLanguage: "",
      // 初回無料か
      isFreeTime: true,

      showReceptionFin: false,
      showFreeTime: false,
      disabledUseCoupon: false,
      disabledPurchaseType: false,
      disabledAmount: false,
    };
  },
  async beforeRouteEnter(to, route, next) {
    let reviewForm = {};
    if (!(to.path == "/review/draft")) {
      reviewForm = await getReview(to.params.dealId);
    }

    const userProfile = (await getUserProfile());

    // 初回無料受付中か？
    var dt = new Date();
    var y = dt.getFullYear();
    var m = ("00" + (dt.getMonth() + 1)).slice(-2);
    var d = ("00" + dt.getDate()).slice(-2);
    var today = y + m + d;
    const freeTime = await getFreeTime(today);

    next((vm) => {
      vm.$data.showFreeTime = userProfile.isFreeTime
      if (userProfile.isFreeTime) {
        if (freeTime.date == today) {
          if (freeTime.isReception == true) {
            vm.$data.disabledUseCoupon = false;
            vm.$data.showReceptionFin = false;
          } else {
            vm.$data.disabledUseCoupon = true;
            vm.$data.showReceptionFin = true;
          }
        } else {
          //受付情報が無かった場合はどうするのか？
          vm.$data.showFreeTime = false;
        }
      }
      
      vm.$store.dispatch("initReviewForm");
      if (!(to.path == "/review/draft")) {
        if (!reviewForm) {
          vm.$data.allowLeave = true;
          vm.$router.replace({ name: "Top" });
          return;
        }
        vm.$data.reviewData = reviewForm;
        vm.$data.disabledAmount = vm.$data.reviewData.isUseCoupon;

        let setOptionExtension = () => {
          var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
          var abstractExtension = localSkill.filter((v) => v.type == Language).map((v) => v.extension);
          var extensionList = abstractExtension.concat(genericExtension).sort();
          vm.$data.optionExtension.push({ value: 0, text: "入力してください" });
          for (var i = 0; i < extensionList.length; i++) {
            vm.$data.optionExtension.push({ value: i + 1, text: "." + extensionList[i] });
          }
          vm.$data.optionExtension.push({ value: extensionList.length + 1, text: "その他" });
        };

        let setCodemirror = (codeEditor: CodeEditorSegmegment[]) => {
          var code = [] as Array<string>;
          var cmOptions = [] as Array<EditorConfiguration>;
          let theme = vm.$store.getters.userProfile.codeTheme == "2" ? "base16-light" : "base16-dark";
          for (var i = 0; i < codeEditor.length; i++) {
            let text = codeEditor[i].text;
            let string = "";
            for (var j = 0; j < text.length; j++) {
              if (j === text.length - 1) {
                string += text[j].code;
              } else {
                string += text[j].code + "\n";
              }
            }
            code.push(string);
            cmOptions.push({
              theme: theme,
              tabSize: 4,
              lineNumbers: true,
              lineWrapping: true,
              mode: codeEditor[i].extension,
              readOnly: false,
            });
          }
          vm.$data.code = code;
          vm.$data.cmOptions = cmOptions;
        };

        let addCodeEditor = () => {
          vm.$data.countCodeBlock += 1;
          var ret = ("00" + this.countCodeBlock).slice(-2);
          var defaultName = "code-" + ret;
          vm.$data.reviewData.codeEditor.push({
            fileName: defaultName,
            extension: "",
            text: [
              {
                line: 1,
                code: "",
              },
            ],
            remarks: "",
          });
          let theme = vm.$store.getters.userProfile.codeTheme == "2" ? "base16-light" : "base16-dark";
          vm.$data.code.push("");
          vm.$data.cmOptions.push({
            theme: theme,
            tabSize: 4,
            lineNumbers: true,
            lineWrapping: true,
            mode: "",
            readOnly: false,
          });
        };

        let setInitialAmount = () => {
          var amount = vm.$data.reviewData.amount;
          var amoObject = vm.$data.optionAmount.filter((v: { text: any }) => v.text.replace(",","") == amount);
          if (amoObject.length) {
            vm.$data.selectAmount = amoObject[0].value;
          } else {
            vm.$data.selectAmount = 3;
            vm.$data.inputAmount = String(amount);
          }
        };

        let splitTags = (): string[] => {
          var tags = vm.$data.reviewData.tags;
          if (tags) {
            return vm.$data.reviewData.tags.split(",");
          } else {
            return [];
          }
        };

        let setOrderSkills = (skills: Skill[]) => {
          vm.$data.orderSkills = [];
          for (var i = 0; i < splitTags.length; i++) {
            var skillName = splitTags()[i];
            var level = skills.find((v) => v.skillName == skillName)?.level || 0;
            vm.$data.orderSkills.push({ skillName: skillName, level: level });
          }
        };

        let setInitialOrderSkill = () => {
          var skills = vm.$data.reviewData.orderSkills;
          setOrderSkills(skills ?? []);
          if (skills) {
            vm.$data.selectOrderSkill = 1;
          } else {
            vm.$data.selectOrderSkill = 0;
          }
        };

        setOptionExtension();
        if (vm.$data.reviewData.codeEditor.length) {
          setCodemirror(vm.$data.reviewData.codeEditor);
        } else {
          addCodeEditor();
        }

        setInitialAmount();
        setInitialOrderSkill();
      }
    });
  },
  created() {
    if (this.mq == "sp") {
      this.$emit("errorToast", "スマートフォンからは依頼作成・編集ができません。");
      this.$router.push({ name: "Top" });
    }
    // アカウントステータスの確認
    if (this.loginData.accountStatus == "3") {
      this.allowLeave = true;
      this.$emit("errorToast", "アカウント制限中のため、依頼作成ができません。");
      this.$router.push({ name: "Top" });
    }

    this.initData();
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.$browserBackFlg) {
      // ブラウザバック以外の場合
      // ガイド.よくある質問は別タブ
      if (to.path == "/guide" || to.path == "/faq") {
        window.open(to.path, "_blank");
        return;
      }
    }
    if (!this.allowLeave) {
      // ページ離脱を許されていない場合
      if (!(to.name == "ReviewDraftConfirm" || to.name == "ReviewConfirm")) {
        // 確認画面を除く
        if (await this.editDone()) {
          // 編集したか
          this.goBack = this.$browserBackFlg; // ブラウザバックであるか
          this.reaveModalOpen(to.path);
          next(false);
          return;
        }
      }
    }
    this.allowLeave = false;
    next();
  },

  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    dealId(): string {
      return this.$route.params.dealId;
    },
    isNewReview(): boolean {
      return this.$route.path == "/review/draft";
    },
    // タグ 関連
    splitTags(): string[] {
      var tags = this.reviewData.tags;
      if (tags) {
        return this.reviewData.tags.split(",");
      } else {
        return [];
      }
    },
    /** 受注方法が「入札」かどうか */
    isTender(): boolean {
      return this.reviewData.purchaseType === "1";
    },
    /** 掲載期限切れかどうか */
    isExpired(): boolean {
      const remainingDaysCount = getDaysCountToEndDate(new Date(this.reviewData.publishedPeriod));
      return remainingDaysCount < 0;
    },
    getPurchaseName(): string {
      if (this.reviewData.purchaseType === "1") {
        return "入札";
      } else {
        return "即決";
      }
    },
    getLimitCountName(): string {
      if (this.reviewData.limitCount == 0) {
        return "上限なし";
      } else {
        return this.reviewData.limitCount + "人";
      }
    },
    getAutoTenderName(): string {
      if (this.reviewData.autoTenderType) {
        return "あり";
      } else {
        return "なし";
      }
    },
    getTenderPriorityName(): string {
      switch (this.reviewData.tenderPriority) {
        case "0":
          return "未設定";
        case "1":
          return "スキルが最も高い";
        case "2":
          return "評価が最も高い";
        case "3":
          return "金額が最も安い";
        case "4":
          return "金額が最も高い";
        default:
          return "未設定";
      }
    },
  },
  watch: {
    // 受注必須スキル 関連
    orderSkills: {
      handler() {
        this.setFormOrderSkills();
      },
      deep: true,
    },
    showOrderSkills() {
      this.setFormOrderSkills();
    },
  },
  methods: {
    async initData() {
      const storeReviewForm = this.$store.getters.reviewForm as ReviewForm;
      if (storeReviewForm.dealId == this.dealId && storeReviewForm.title) {
        this.reviewData = JSON.parse(JSON.stringify(storeReviewForm));
      } else {
        this.$store.dispatch("initReviewForm");
        if (this.isNewReview) {
          this.reviewData = JSON.parse(JSON.stringify(this.$store.getters.reviewForm as ReviewForm));
        } else {
          const reviewForm = await this.getReview(this.dealId);
          if (!reviewForm) {
            this.allowLeave = true;
            this.$router.replace({ name: "Top" });
            return;
          }
          this.reviewData = reviewForm;
        }
      }
      this.setOptionExtension();
      if (this.reviewData.codeEditor.length) {
        this.setCodemirror(this.reviewData.codeEditor);
      } else {
        this.addCodeEditor();
      }
      this.setInitialAmount();
      this.setInitialOrderSkill();
    },
    // レビュー取得
    async getReview(dealId: string) {
      try {
        const res = await getReview(dealId);
        // 依頼者がログインである&&（取引ステータスが下書き||受注待ちである）
        if (res.purchaseUserId == this.loginData.userId && (res.dealStatus == Draft || res.dealStatus == Pending)) {
          return toReviewFormFromGetReview(res);
        }
      } catch (e) {
        console.log(e);
      }
    },
    // メイン言語 関連
    setFormLanguage(value: string) {
      this.beforeLanguage = this.reviewData.language;
      this.reviewData.language = value;
      this.changeExtToChoseLanguage(value);
    },
    // コードエディター 関連
    setOptionExtension() {
      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var abstractExtension = localSkill.filter((v) => v.type == Language).map((v) => v.extension);
      var extensionList = abstractExtension.concat(genericExtension).sort();
      this.optionExtension.push({ value: 0, text: "入力してください" });
      for (var i = 0; i < extensionList.length; i++) {
        this.optionExtension.push({ value: i + 1, text: "." + extensionList[i] });
      }
      this.optionExtension.push({ value: extensionList.length + 1, text: "その他" });
    },
    setInitialExt(ext: string) {
      if (ext !== "") {
        var extObject = this.optionExtension.filter((v) => v.text === ext);
        if (extObject.length) {
          return extObject[0].value;
        } else {
          return this.optionExtension.length - 1;
        }
      } else {
        return 0;
      }
    },
    changeExt(newExt: number, key: number) {
      var match = this.optionExtension.filter((v) => v.value === newExt)[0];
      if (match.text === "入力してください") {
        this.reviewData.codeEditor[key].extension = "";
        if (this.cmOptions[key]) {
          // コードミラーオプションを生成する前に走る予防
          this.cmOptions[key].mode = "";
        }
      } else {
        this.reviewData.codeEditor[key].extension = match.text;
        if (this.cmOptions[key]) {
          // コードミラーオプションを生成する前に走る予防
          this.cmOptions[key].mode = match.text;
        }
      }
    },
    changeExtToChoseLanguage(lang: string) {
      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var extensions = localSkill.filter((v) => v.skillName == lang).map((v) => v.extension);
      var beforeExtensions = localSkill.filter((v) => v.skillName == this.beforeLanguage).map((v) => v.extension);
      if (!extensions.length) {
        return;
      }
      var extensionOfSelectedLanguage = this.optionExtension.filter((c) => c.text == "." + extensions[0])[0];
      this.reviewData.codeEditor.forEach((c) => {
        if ((beforeExtensions.length != 0 && c.extension == "." + beforeExtensions[0]) || c.extension == "") {
          // 選択言語変更時、変更前の言語とマッチする拡張子または拡張子が選択されていない場合に拡張子の変更を行う
          c.extension = lang == "その他" ? "" : extensionOfSelectedLanguage.text;
        }
      });
    },

    setCodemirror(codeEditor: CodeEditorSegmegment[]) {
      var code = [] as Array<string>;
      var cmOptions = [] as Array<EditorConfiguration>;
      let theme = this.loginData.codeTheme == "2" ? "base16-light" : "base16-dark";
      for (var i = 0; i < codeEditor.length; i++) {
        let text = codeEditor[i].text;
        let string = "";
        for (var j = 0; j < text.length; j++) {
          if (j === text.length - 1) {
            string += text[j].code;
          } else {
            string += text[j].code + "\n";
          }
        }
        code.push(string);
        cmOptions.push({
          theme: theme,
          tabSize: 4,
          lineNumbers: true,
          lineWrapping: true,
          mode: codeEditor[i].extension,
          readOnly: false,
        });
      }
      this.code = code;
      this.cmOptions = cmOptions;
    },
    addCodeEditor() {
      this.countCodeBlock += 1;
      var ret = ("00" + this.countCodeBlock).slice(-2);
      var defaultName = "code-" + ret;

      var localSkill = JSON.parse(localStorage.getItem("skill") as string) as SkillMastar[];
      var extensions = localSkill.filter((v) => v.skillName == this.reviewData.language).map((v) => v.extension);
      var extensionOfSelectedLanguage = "";
      if (extensions.length != 0) {
        extensionOfSelectedLanguage =
          this.reviewData.language == "その他"
            ? ""
            : this.optionExtension.filter((c) => c.text == "." + extensions[0])[0].text;
      }

      this.reviewData.codeEditor.push({
        fileName: defaultName,
        extension: extensionOfSelectedLanguage,
        text: [
          {
            line: 1,
            code: "",
          },
        ],
        remarks: "",
      });
      let theme = this.loginData.codeTheme == "2" ? "base16-light" : "base16-dark";
      this.code.push("");
      this.cmOptions.push({
        theme: theme,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
        mode: "",
        readOnly: false,
      });
    },
    deleteCodeEditor() {
      this.reviewData.codeEditor.splice(this.selectedCodeEditor, 1);
      this.code.splice(this.selectedCodeEditor, 1);
      this.cmOptions.splice(this.selectedCodeEditor, 1);
      this.modalClose();
    },
    setFormCode() {
      for (var i = 0; i < this.code.length; i++) {
        this.reviewData.codeEditor[i].text = [];
        if (!this.code[i]) {
          continue;
        }
        var code = this.code[i].split(/\n/);
        for (var j = 0; j < code.length; j++) {
          this.reviewData.codeEditor[i].text.push({ line: j + 1, code: code[j] });
        }
      }
    },
    // 初回無料クーポンを使うか？
    changeUseCoupon(check: boolean) {
      if (check) {
        this.changePurchaseType(2);
        this.disabledPurchaseType = true;
        this.disabledAmount = true;
        this.reviewData.amount = 0;
      } else {
        this.changePurchaseType(1);
        this.disabledPurchaseType = false;
        this.disabledAmount = false;
        this.reviewData.amount = 3000;
      }
    },
    // 受注方法関連
    changePurchaseType(purchaseType: number) {
      this.reviewData.purchaseType = purchaseType.toString() as PurchaseType;
    },
    // 金額 関連
    setInitialAmount() {
      var amount = this.reviewData.amount;
      var amoObject = this.optionAmount.filter((v) => parseInt(v.text.replace(",",""),10) == amount);
      if (amoObject.length) {
        this.selectAmount = amoObject[0].value;
      } else {
        this.selectAmount = 3;
        this.inputAmount = String(amount);
      }
    },
    /**
     * 金額の変更
     */
    changeAmount(newAmount: number) {
      if (newAmount == 3) {
        this.reviewData.amount = Number(this.inputAmount);
        this.showInputAmount = true;
      } else {
        var amoObject = this.optionAmount.filter((v) => v.value == newAmount);
        this.reviewData.amount = Number(amoObject[0].text.replace(",",""));
        this.showInputAmount = false;
      }
    },
    setFormAmount(newAmount: string) {
      this.reviewData.amount = Number(newAmount);
    },
    // 入札人数上限関連
    changeLimitCount(limitCount: number) {
      this.reviewData.limitCount = limitCount;
    },
    // 自動再掲載関連
    changeAutoTenderType(autoTenderType: number) {
      this.reviewData.autoTenderType = autoTenderType.toString() as AutoTenderType;
    },
    // 落札の優先度設定関連
    changeTenderPriority(tenderPriority: number) {
      this.reviewData.tenderPriority = tenderPriority.toString() as TenderPriority;
    },
    // タグ 関連
    setFormTags(value: string[]) {
      this.reviewData.tags = value.join(",");
      this.setOrderSkills(this.orderSkills);
    },
    deleteTags(index: number) {
      this.splitTags.splice(index, 1);
      this.setFormTags(this.splitTags);
    },
    // 掲載期限 関連
    changePublishedPeriod(newPublishedPeriod: PublishedOption) {
      this.reviewData.selectPublishedPeriod = newPublishedPeriod;
    },
    /**
     * 編集された掲載期限を反映する
     *
     * 編集時点の現在時刻から満1, 3, 7, 30, 90日後が掲載期限となる
     */
    setFormPublishedPeriod() {
      // newまたは下書き状態のとき: 現在時刻から掲載期限を計算
      if (this.isNewReview || this.reviewData.dealStatus == Draft) {
        this.reviewData.publishedPeriod = calcPublishedPeriod(
          moment(),
          this.reviewData.selectPublishedPeriod
        ).toISOString();
      }
    },
    // 受注必須スキル 関連
    setInitialOrderSkill() {
      var skills = this.reviewData.orderSkills;
      this.setOrderSkills(skills ?? []);
      if (skills) {
        this.selectOrderSkill = 1;
      } else {
        this.selectOrderSkill = 0;
      }
    },
    changeOrderSkill(toggle: number) {
      if (toggle == 0) {
        this.showOrderSkills = false;
      } else if (toggle == 1) {
        this.showOrderSkills = true;
      }
    },
    setOrderSkills(skills: Skill[]) {
      this.orderSkills = [];
      for (var i = 0; i < this.splitTags.length; i++) {
        var skillName = this.splitTags[i];
        var level = skills.find((v) => v.skillName == skillName)?.level || 0;
        this.orderSkills.push({ skillName: skillName, level: level });
      }
    },
    setFormOrderSkills() {
      if (this.showOrderSkills) {
        this.reviewData.orderSkills = this.orderSkills.filter((v) => v.level > 0);
      } else {
        this.reviewData.orderSkills = null;
      }
    },
    // モーダル 関連
    reaveModalOpen(path: string) {
      this.modalOpen = true;
      this.reaveModal = true;
      this.nextPath = path;
    },
    deleteEditorModalOpen(index: number) {
      this.modalOpen = true;
      this.deleteEditorModal = true;
      this.selectedCodeEditor = index;
    },
    deleteModalOpen() {
      this.modalOpen = true;
      this.deleteModal = true;
    },
    draftModalOpen() {
      this.modalOpen = true;
      this.draftModal = true;
    },
    modalClose() {
      this.modalOpen = false;
      this.reaveModal = false;
      this.deleteEditorModal = false;
      this.deleteModal = false;
      this.draftModal = false;
    },
    // 確認画面へ
    toConfirm() {
      // 初回無料管理チェック
      if (this.reviewData.isUseCoupon) {
        const languages = ['Java', 'Kotlin', 'HTML', 'JavaScript', 'CSS']
        if (!languages.includes(this.reviewData.language)) {
          this.$emit("errorToast", "この言語では初回無料依頼ができません");
          return;
        }
      }
      this.reviewSubmit("confirm");
    },
    // レビュー削除
    async deleteReview() {
      try {
        await deleteReview(this.reviewData.dealId as string);
        this.$store.dispatch("initReviewForm");
        this.allowLeave = true;
        this.$router.push({ name: "DealsManagement" });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit('errorToast', resError.message);
          } else {
            this.$emit('errorToast', "削除処理に失敗しました。");
          }
        }
      }
    },
    // 下書き保存する
    saveDraft() {
      this.reviewSubmit("draft");
    },
    // 下書きに戻す
    backDraft() {
      this.reviewSubmit("draftBack");
    },
    // 破棄
    destroy() {
      this.modalClose();
      this.$store.dispatch("initReviewForm");
      this.allowLeave = true;
      if (this.goBack) {
        this.$router.go(-1);
      } else {
        this.$router.push(this.nextPath);
      }
    },
    // ページ離脱による下書き保存 or 編集内容を保存
    saveLeave() {
      this.reviewSubmit("save");
    },
    // 汎用
    validation() {
      var form = this.reviewData;
      var titleLength = 100;
      var purchaseOverviewLength = 500;
      var fileNameLength = 50;
      var amountMin = 3000;
      var amountMax = 20000;
      // 言語
      if (!form.language) {
        return { result: false, message: "言語を選択してください" };
      }
      // タイトル
      if (!form.title.trim()) {
        return { result: false, message: "タイトルを入力してください" };
      }
      if (form.title.length > titleLength) {
        return {
          result: false,
          message: "タイトルを" + titleLength + "文字以内で入力してください。文字数：" + form.title.length,
        };
      }
      // 依頼概要
      if (!form.purchaseOverview.trim()) {
        return { result: false, message: "依頼概要を入力してください" };
      }
      if (form.purchaseOverview.length > purchaseOverviewLength) {
        return {
          result: false,
          message:
            "依頼概要を" +
            purchaseOverviewLength +
            "文字以内で入力してください。文字数：" +
            form.purchaseOverview.length,
        };
      }
      // コードエディタ
      for (let i = 0; i < form.codeEditor.length; i++) {
        const codeEditor = form.codeEditor[i];

        // NOTE: 以下に該当する場合は、ファイル名・拡張子のチェックを行う
        //       ・1つ目のコードエディタの場合
        //       ・2つ目以降のコードエディタ 且つ コード本文の入力がある場合
        if (i === 0 || (i > 0 && !!codeEditor.text.length)) {
          // ファイル名
          if (!codeEditor.fileName.trim()) {
            return { result: false, message: "ファイル名を入力してください" };
          }
          if (codeEditor.fileName.length > fileNameLength) {
            return {
              result: false,
              message:
                "ファイル名を" +
                fileNameLength +
                "文字以内で入力してください。対象ファイル名：" +
                codeEditor.fileName +
                codeEditor.extension +
                "、文字数：" +
                codeEditor.fileName.length,
            };
          }
          // 拡張子
          if (!codeEditor.extension) {
            return { result: false, message: "すべてのエディタで拡張子を選択してください" };
          }
          // ファイル名+拡張子の重複
          const duplicate = form.codeEditor.filter(
            (v) => v.fileName == codeEditor.fileName && v.extension == codeEditor.extension
          );
          if (duplicate.length > 1) {
            return {
              result: false,
              message: "ファイル名が重複しています。対象ファイル名：" + codeEditor.fileName + codeEditor.extension,
            };
          }
        }

        // 1つ目のコードエディタのみ、コード本文の入力は必須とする
        if (i === 0) {
          // コード本文
          if (!codeEditor.text.length) {
            return {
              result: false,
              message: "コード本文を入力してください。対象ファイル名：" + codeEditor.fileName + codeEditor.extension,
            };
          }
        }
      }
      // 金額
      if (!this.reviewData.isUseCoupon) {
        if (isNaN(form.amount) || form.amount < amountMin || amountMax < form.amount) {
          return {
            result: false,
            message: "金額を" + amountMin.toLocaleString() + "円以上" + amountMax.toLocaleString() + "円以内で入力してください",
          };
        }
        if (Math.floor(form.amount / 100) * 100 !== form.amount) {
          // 金額が 100 円単位の入力になっているか
          return { result: false, message: "金額は100円単位で入力してください" };
        }
      }
      // 受注必須スキル
      if (this.showOrderSkills && !form.orderSkills!.length) {
        return { result: false, message: "受注必須スキルがある場合には必ず一つ以上にレベルを指定してください" };
      }
      return { result: true, message: "" };
    },
    format() {
      var form = this.reviewData;
      form.title = form.title.trim();
      form.purchaseOverview = form.purchaseOverview.trim();
    },
    async reviewSubmit(action: string) {
      // アカウントステータスの確認
      await this.$store.dispatch("updateAccountStatus");
      if (this.loginData.accountStatus == "3") {
        this.allowLeave = true;
        this.$emit("errorToast", "アカウント制限中のため、依頼作成ができません。");
        await this.$router.push({ name: "Top" });
        return;
      }

      this.setFormCode();
      this.setFormPublishedPeriod();

      // 「保存・下書き保存」以外はバリデーションチェック
      if (!["save", "draft"].includes(action)) {
        var validation = this.validation();
        if (!validation.result) {
          this.$emit("errorToast", validation.message);
          return;
        }
      }

      this.format();
      if (action == "confirm") {
        // NOTE: 既にバリデーションチェックが通っている前提で、コード本文入力あるものだけを store に格納
        const codeEditor = this.reviewData.codeEditor.filter(({ text }) => !!text.length);
        this.$store.dispatch("updateReviewForm", {
          form: {
            ...this.reviewData,
            codeEditor,
          },
        });
        this.allowLeave = true;
        if (this.isNewReview) {
          this.$router.push({ name: "ReviewDraftConfirm" });
        } else {
          this.$router.push({ name: "ReviewConfirm", params: { dealId: this.reviewData.dealId as string } });
        }
      } else if (action == "draft") {
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.reviewData.dealId = res.dealId;
            this.reviewData.createDate = res.createDate;
            this.reviewData.dealStatus = "1";
            this.$emit("toast", "下書き保存しました");
            this.$store.dispatch("updateReviewForm", { form: this.reviewData });
            this.allowLeave = true;
            this.$router.replace({ name: "ReviewEdit", params: { dealId: this.reviewData.dealId } });
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書き）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
            this.$emit("toast", "下書き保存しました");
          }
        } catch (e) {
          console.log(e);
        }
      } else if (action == "draftBack") {
        try {
          // 決済キャンセル 取引ステータス:受注待ち⇒下書き
          await updateReviewStatus(this.reviewData.dealId as string, { dealStatus: "1" });
          this.reviewData.dealStatus = "1";
          // レビュー更新API 取引ステータス:そのまま（下書き⇒下書き）
          await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
          this.modalClose();
          this.$emit("toast", "下書きに戻しました");
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit('errorToast', resError.message);
            } else {
              this.$emit('errorToast', "下書きに戻す処理に失敗しました。");
            }
          }
        }
      } else if (action == "save") {
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.$emit("toast", "下書き保存しました");
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書きor受注待ち⇒受注待ち）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
            this.$emit("toast", "編集内容を保存しました");
          }
          this.destroy();
        } catch (e) {
          console.log(e);
        }
      }
    },
    /** 編集したかどうか */
    async editDone() {
      this.setFormCode();
      if (this.isNewReview) {
        // 編集有無を判定する
        const initialReviewData: ReviewForm = emptyReviewForm();
        const currentReviewData = this.reviewData;
        const edited = Object.entries(currentReviewData).some(([key, value]) => {
          switch (key) {
            case "codeEditor":
              const codeEditor = value as CodeEditorSegmegment[];

              // エディタ行が追加されている場合、編集有りと判定
              if (codeEditor.length > 1) {
                return true;
              }

              const [firstCodeEditor] = codeEditor;

              // 何かしらコードエディタの入力内容が変わっていれば、編集有りと判定
              return (
                firstCodeEditor.fileName !== "code-01" ||
                firstCodeEditor.extension !== "" ||
                firstCodeEditor.remarks !== "" ||
                firstCodeEditor.text.some(({ code }) => !!code)
              );
            default:
              return value !== initialReviewData[key as keyof ReviewForm];
          }
        });
        return edited;
      } else {
        // API 保存済みの依頼内容と比較し、編集有無を判定する
        const reviewForm = await this.getReview(this.reviewData.dealId as string);
        if (!reviewForm) {
          return false;
        }
        const oldReviewData = reviewForm;
        const newJSON = JSON.stringify(this.reviewData);
        const oldJSON = JSON.stringify(oldReviewData);

        if (newJSON != oldJSON) {
          return true;
        } else {
          return false;
        }
      }
    },
    alertSkill(message: string) {
      this.$emit("errorToast", message);
    },
    setColorClass(lang: string): string {
      return getColorClass(lang);
    },
  },
  filters: {
    remainingDays(period: string): string {
      const remain = getDaysCountToEndDate(new Date(period));
      return remain < 0 ? "期限切れ" : `残り ${remain} 日`;
    },
    formatDate(date: string, fmt: string): string {
      return moment(date).format(fmt);
    },
  },
});
